import {
  SET_ACCEPTED_ORDERS,
  SET_PENDING_ORDERS,
  SET_ORDER_TO_ACCEPTED,
  SET_ORDER_TO_DECLINED,
  SET_ORDER_TO_DELIVERED,
  SET_HISTORY_ORDERS,
  SET_SUBMITTING,
  CLEAR_SUBMITTING,
  ARRIVED,
  DELIVERED
} from './constants';

const initialState = {
  accepted: null,
  history: null,
  pending: null,
  submitting: {},
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_ACCEPTED_ORDERS:
      return {
        ...state,
        accepted: action.payload,
      };
    case SET_PENDING_ORDERS:
      return {
        ...state,
        pending: action.payload,
      };
    case SET_HISTORY_ORDERS:
      return {
        ...state,
        history: action.payload,
      };
    case SET_ORDER_TO_ACCEPTED:
      return {
        ...state,
        pending: state.pending.map((delivery) => {
          if (action.payload.id === delivery.id) {
            delivery.status = ARRIVED;
          }

          return delivery;
        }),
      };
    case SET_ORDER_TO_DECLINED:
      return {
        ...state,
        pending: state.pending.filter(p => p.id !== action.payload.id),
      };
    case SET_ORDER_TO_DELIVERED:
      return {
        ...state,
        pending: state.pending.filter(delivery => delivery.orderId !== action.payload.orderId),
        history: state.history.concat({ ...action.payload, status: DELIVERED }),
      };
    case SET_SUBMITTING:
      return {
        ...state,
        submitting: { ...state.submitting, [action.payload]: true },
      };
    case CLEAR_SUBMITTING: {
      const next = { ...state.submitting };
      delete next[action.payload];
      return { ...state, submitting: next };
    }
    default:
      return state;
  }
};

export default reducer;